// extracted by mini-css-extract-plugin
export default {"noPlansPage":"styles_noPlansPage__7PXeP","button":"styles_button__AIN9P","fullView":"styles_fullView__iB4oF","shimmer":"styles_shimmer__D-Ukl"};